export interface QueryParams {
  query: string;
  variables: any;
  operationName?: string;
}

export enum PaymentResponseType {
  success = 'payment-success',
  error = 'payment-error',
}

export enum PaymentGateway {
  stripe = 'stripe',
  braintree = 'braintree',
  xendit = 'xendit',
  moneris = 'moneris',
  authorizeNet = 'authorizenet',
  heartland = 'heartland',
  eghl = 'eghl',
}
export interface UserBalanceResponse {
  userBalance: UserBalance[];
}
export interface UserBalance {
  AccountName: string;
  Balance: number;
  GroupID: null | string;
}

export interface GetPaymentConfigurationsResponse {
  getPaymentConfigurations: GetPaymentConfigurations;
}

export interface GetPaymentConfigurations {
  payment: Payment[];
}

export interface Payment {
  _id: string;
  CustomerID: string;
  PaymentType: string;
  PaymentName: string;
  Stripe: Stripe | null;
}

export interface Stripe {
  SecretKey: string;
  PublicKey: string;
}
export interface GetStripeLinkResponse {
  getStripeRedirectUrl: {
    message: string;
    statusCode: string;
  };
}

export interface GetBraintreeTokenResponse {
  getBrainTreeClientToken: GetBrainTreeClientToken;
}

export interface GetBrainTreeClientToken {
  StatusCode: number;
  Message: string;
  Token: string;
}

export interface GetXenditInvoiceResponse {
  getXenditInvoiceURL: GetXenditInvoiceURL;
}

export interface GetXenditInvoiceURL {
  StatusCode: number;
  Message: string;
  PayURL: string;
}

export interface GetMonerisTicketResponse {
  getMonerisTicket: GetMonerisTicket;
}

export interface GetMonerisTicket {
  StatusCode: number;
  Message: string;
  Ticket: string;
}

export interface GetAuthorizeNetClientTokenResponse {
  getAuthorizeNetClientToken: GetAuthorizeNetClientToken;
}

export interface GetAuthorizeNetClientToken {
  token: null;
  statusCode: number;
  message: string;
}
export interface GetHeartlandHashResponse {
  getHeartlandHash: GetHeartlandHash;
}
export interface GetHeartlandHash {
  Hash: string;
  Message: string;
  OrderID: string;
  StatusCode: number;
  Timestamp: string;
  MerchantID: string;
  Currency: string;
  Amount: string;
}

export interface CustomHttpHeader {
  Authorization: string;
  tier: string;
  subdomain: string;
}

export interface GetNayaxCheckoutResponse {
  getNayaxCheckout: GetNayaxCheckout;
}
export interface GetNayaxCheckout {
  TransactionID: string;
  Message: string;
  StatusCode: number;
}

export interface GetEGHLHashResponse {
  getEghlHash: GetEGHLHash;
}
export interface GetEGHLHash {
  ServiceID: string;
  Message: string;
  StatusCode: number;
  OrderNumber: string;
  PaymentID: string;
  PageTimeout: string;
  Amount: Number;
  CurrencyCode: string;
  Hash: string;
  CallbackURL: string;
  ReturnURL: string;
  UnApprovalURL: string;
  ApprovalURL: string;
}
